const $$ = (selector, parent = document) => parent.querySelectorAll(selector);

function initializeHubspotForms() {
  const formTargets = $$("#hubspot-form[data-form-id]");

  formTargets.forEach(formTarget => {
    const formID = formTarget.getAttribute("data-form-id");

    if (!formID) {
      return;
    }

    formTarget.innerHTML = "";

    hbspt.forms.create({
      region: "na1",
      portalId: "177078",
      formId: formID,
      target: `#${formTarget.id}`
    });
  });
}

function ensureHubspotFormsScript() {
  if (window.hbspt?.forms?.create) {
    initializeHubspotForms();
    return;
  }

  (window.hsFormsOnReady ||= []).push(() => {
    initializeHubspotForms();
  });

  if (!document.querySelector('script[src="//js.hsforms.net/forms/v2.js"]')) {
    const script = document.createElement("script");
    script.async = true;
    script.charset = "utf-8";
    script.type = "text/javascript";
    script.src = "//js.hsforms.net/forms/v2.js";
    document.head.appendChild(script);
  }
}

ensureHubspotFormsScript();
